(($) => {
	// Initialise color picker
	$('.nb-color-picker').colorpicker({
		format: 'hex',
		autoInputFallback: false,
	}).on('colorpickerChange colorpickerCreate colorpickerUpdate', (e) => {
		// Color preview
		e.colorpicker.element.parents('.form-group').find('.nb-color-picker-preview').css('background-color', e.colorpicker.element.val());
	});
})(jQuery);